<template>
  <div class="welcome">
    <div>
      <el-row :gutter="4">
        <el-col :span="7"></el-col>
        <el-col :span="11">
          <div style="font-size: 30px;color: white;">中级消防设施操作员模拟系统</div>
        </el-col>
        <el-col :span="6">
            <el-menu mode="horizontal" >
              <el-sub-menu  index="1">
                <template #title>
                  <div style="font-size: 20px;border-bottom-color: transparent;">欢迎[{{loginNickName}}]</div>
                </template>
                <el-menu-item @click="handleToPage('/')" index="home">首页</el-menu-item>
                <el-menu-item @click="handleToPage('/userInfo/UserInfoHome')" index="userInfo">个人中心</el-menu-item>
                <el-menu-item @click="logout()" index="logout">登出</el-menu-item>
              </el-sub-menu>
            </el-menu>
        </el-col>

      </el-row>
    </div>


  </div>
  <div v-if="isBuy" class="subjectBackground">
    <el-row :gutter="10" style="height:50px;padding-top: 20px">
      <el-col :span="4">
      </el-col>
      <el-col :span="5">
        <div style="font-size: 20px; color: white;">鉴定站:</div>
      </el-col>
      <el-col :span="5">
        <el-select
            v-model="buyAreaValue"
            placeholder="请选择地区"
        >
          <el-option v-for="item in buyAreaOptions" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="5">
        <el-link style="font-size: large;color: blue" @click="handleToPage('/buyPage')">>>购买</el-link>
        <el-link style="font-size: large;color: blue" @click="handleToPage('/userInfo/UserInfoHome')">>>积分兑换(新用户可用初始积分兑换60分钟的VIP体验)</el-link>
      </el-col>
    </el-row>
    <el-row :gutter="10" style="height:100px">
      <el-col :span="4">
      </el-col>
      <el-col :span="5">
        <div style="font-size: 20px; color: white;">请选择学习方式:</div>
      </el-col>
      <el-col :span="5">
        <el-radio-group v-model="studyType" class="custom-radio-group">
          <el-radio label="practice">练习</el-radio>
          <el-radio label="exam">考试</el-radio>
        </el-radio-group>
      </el-col>
    </el-row>
    <el-row :gutter="10" style="height:480px">
      <el-col :span="6" ></el-col>
      <el-col :span="7" v-for="modeImage in modeImagesNormal" :key="modeImage.id"
              :style="{ backgroundImage: `url(${modeImage.path})` }"
              @mouseenter="handleMouseEnterNormal(modeImage)"
              @mouseleave="handleMouseLeaveNormal(modeImage)"
              @click ="handleToChoosePage(modeImage.toNormalPracticePage,modeImage.toNormalExamPage,'normal', modeImage.subjectType)"
              class="mode-col">
        <div style="width: 200px;height: 300px; align-content: center">

          <div style="font-size: medium;text-align: center;vertical-align: center">
            <img :src="modeImage.icon" style="height: 100px;width: 100px;align-content: center;" alt="icon"/>
            <p/>{{ modeImage.title }}
          </div>
          <p></p>
          <div style="font-size: small;text-align: center;vertical-align: center">{{ modeImage.desc }}</div>
        </div>
      </el-col>
    </el-row>
  </div>
  <div v-if="!isBuy" class="subjectBackground">
<!--    <el-row :gutter="10" style="height:10px;"></el-row>-->
    <el-row :gutter="10" style="padding-top: 20px">
      <el-col :span="4">
      </el-col>
      <el-col :span="5">
        <div style="font-size: 20px; color: white">鉴定站:</div>
      </el-col>
      <el-col :span="5">
        <el-cascader
            v-model="finalAreaValue"
            :options="areaOptions"
            @change="areaChange"
            placeholder="请选择地区"
        ></el-cascader>
      </el-col>
    </el-row>
    <el-row :gutter="10" style="margin-top: 20px">
        <el-col :span="4">
        </el-col>
        <el-col :span="5">
          <div style="font-size: 20px; color: white;">请选择学习方式:</div>
        </el-col>
        <el-col :span="5">
          <el-radio-group v-model="studyType" class="custom-radio-group">
            <el-radio label="practice">练习</el-radio>
            <el-radio label="exam">考试</el-radio>
          </el-radio-group>
        </el-col>
    </el-row>
    <el-row :gutter="10" style="margin-top: 50px">
      <el-col :span="6"></el-col>
      <el-col :span="8" v-for="modeImage in modeImagesTry" :key="modeImage.id"
              :style="{ backgroundImage: `url(${modeImage.path})` }"
              @mouseenter="handleMouseEnterTry(modeImage)"
              @mouseleave="handleMouseLeaveTry(modeImage)"
              @click ="handleToChoosePage(modeImage.toTryPracticePage,modeImage.toTryExamPage,'try', modeImage.subjectType)"
              class="mode-col">
        <div style="width: 200px;height: 300px; align-content: center">

          <div style="font-size: medium;text-align: center;vertical-align: center">
            <img :src="modeImage.icon" style="height: 100px;width: 100px;align-content: center;" alt="icon"/>
            <p/>{{ modeImage.title }}
          </div>
          <p></p>
          <div style="font-size: small;text-align: center;vertical-align: center">{{ modeImage.desc }}</div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>

import cloneDeep from "lodash/cloneDeep";
import router from "@/router";
import request from "@/utils/request";
import {ElMessage} from "element-plus";
import {ref} from "vue";

const loginNickName = localStorage.getItem("loginNickName");

const loginUserId = localStorage.getItem("loginUserId");
const isBuy=ref(false);

async function getAreaAll() {
  await request.get('/area/all',{
    params: {type: "fire"
    }
  }).then(response => {
        const result = response.data; // 将接口返回的数据赋值给result
        if (result.code === "200") {
          areaOptions.value=result.data;
        } else {
          ElMessage.warning(result.msg);
          router.push("/login");
        }
      })
      .catch(error => {
        console.log("getAreaAll error:" + error);
        // ElMessage.error("系统异常，请联系管理员");
      });
}

function getUserAuthorization(type) {
  request.get('/userAuthorization/get',
      {params:{
          userId: loginUserId, type:type
        }
      })
      .then(response => {
        const result = response.data; // 将接口返回的数据赋值给result
        if (result.code === "200") {
          isBuy.value=result.data.length>0;
          if(isBuy.value){
            buyAreaOptions.value=Array.from(result.data.reduce((map, item) => {
              const key = item.areaId;
              if (!map.has(key)) {
                map.set(key, {"id":item.areaId, "name":item.areaName});
              }
              return map;
            }, new Map()).values());
            this.buyAreaValue=buyAreaOptions.value[0].id;
          }
        } else {
          ElMessage.warning(result.msg);
          router.push("/login");
        }
      })
      .catch(error => {
        console.log("TheoryMediumDevice error:" + error);
        // ElMessage.error("系统异常，请联系管理员");
      });
}
const areaOptions=ref([]);

const modeItemImagesTry =
    [{
      id: 1,
      path: require('@/assets/picture/main/mode/trainingModeBlue.png'),
      title: "理论真题",
      desc: "海量题库，在线学习",
      icon: require('@/assets/picture/main/mode/ico/train.png'),
      toTryPracticePage:"/fire/try/practice/TheoryMediumDevice",
      toTryExamPage:"/fire/try/exam/TheoryMediumDevice",
      subjectType:"theory"
    },
      // {
      //   id: 2,
      //   path: require('@/assets/picture/main/mode/trainingModeGreen.png'),
      //   title: "机考实操(必考题)",
      //   desc: "仿真国考，全面覆盖",
      //   icon: require('@/assets/picture/main/mode/ico/mechine.png'),
      //   toTryPracticePage:"/fire/try/practice/MachineMediumDevice",
      //   toTryExamPage:"/fire/try/exam/MachineMediumDevice"
      // },
      {
        id: 2,
        path: require('@/assets/picture/main/mode/trainingModeYellow.png'),
        title: "操作题(必考题+抽考题)",
        desc: "现场环境，模拟线下实操考试",
        icon: require('@/assets/picture/main/mode/ico/personSpeak.png'),
        toTryPracticePage:"/fire/try/practice/PeopleMediumDevice",
        toTryExamPage:"/fire/try/exam/PeopleMediumDevice",
        subjectType:"people"
      }];
const modeItemImagesCopy = cloneDeep(modeItemImagesTry)

const modeItemNormalImages =
    [{
      id: 1,
      path: require('@/assets/picture/main/mode/trainingModeBlue.png'),
      title: "理论真题",
      desc: "海量题库，在线学习",
      icon: require('@/assets/picture/main/mode/ico/train.png'),
      toNormalPracticePage:"/fire/normal/practice/TheoryMediumDevice",
      toNormalExamPage:"/fire/normal/exam/TheoryMediumDevice",
      subjectType:"theory"
    },
      // {
      //   id: 2,
      //   path: require('@/assets/picture/main/mode/trainingModeGreen.png'),
      //   title: "机考实操(必考题)",
      //   desc: "仿真国考，全面覆盖",
      //   icon: require('@/assets/picture/main/mode/ico/mechine.png'),
      //   toNormalPracticePage:"/fire/normal/practice/MachineMediumDevice",
      //   toNormalExamPage:"/fire/normal/exam/MachineMediumDevice"
      // },
      {
        id: 2,
        path: require('@/assets/picture/main/mode/trainingModeYellow.png'),
        title: "操作题(必考题+抽考题)",
        desc: "现场环境，模拟线下实操考试",
        icon: require('@/assets/picture/main/mode/ico/personSpeak.png'),
        toNormalPracticePage:"/fire/normal/practice/PeopleMediumDevice",
        toNormalExamPage:"/fire/normal/exam/PeopleMediumDevice",
        subjectType:"people"
      }];
const modeItemNormalImagesCopy = cloneDeep(modeItemNormalImages)

const buyAreaOptions= ref([]);
const finalAreaValue=ref('');
export default {
  name: "MediumFireDeviceHome",
  async created() {
    await getAreaAll()
    if(loginUserId!==null && loginUserId!==''){
      getUserAuthorization.call(this, "subject");
    }
  },
  data() {
    return {
      loginNickName: loginNickName,
      isBuy: isBuy,
      // areaValue: [], // 下拉框选中的值
      areaOptions: areaOptions,
      modeImagesTry: modeItemImagesTry,
      studyType:'practice',

      modeImagesNormal: modeItemNormalImages,
      buyAreaValue:'',
      buyAreaOptions:buyAreaOptions,
      finalAreaValue:finalAreaValue
    }
  },
  methods: {
    handleMouseEnterTry(modeImage) {
      this.modeImagesTry[modeImage.id - 1].path = require('@/assets/picture/main/mode/trainingModeSelected.png')
    },
    handleMouseLeaveTry(modeImage) {
      modeImage.path = modeItemImagesCopy[modeImage.id - 1].path
    },
    handleMouseEnterNormal(modeImage) {
      this.modeImagesNormal[modeImage.id - 1].path = require('@/assets/picture/main/mode/trainingModeSelected.png')
    },
    handleMouseLeaveNormal(modeImage) {
      modeImage.path = modeItemNormalImagesCopy[modeImage.id - 1].path
    },
    handleToPage(path){
      router.push(path);
    },
    handleToChoosePage(trainPath, examPath, buyMode, subjectType){
      if(!isBuy.value && finalAreaValue.value ===""){
        this.$message.error("请选择鉴定站");
        return;
      }

      if(isBuy.value){
        finalAreaValue.value=this.buyAreaValue;
      }
      if(this.studyType==='practice'){//训练模式
        router.push({path:trainPath,query:{areaId: finalAreaValue.value, studyMode: this.studyType, buyMode:buyMode, subjectType:subjectType}});
      }else {
        router.push({path:examPath,query:{areaId: finalAreaValue.value, studyMode: this.studyType, buyMode:buyMode, subjectType:subjectType}});
      }
    },
    logout() {
      if (localStorage.getItem('loginNickName')) {
        localStorage.removeItem('loginNickName');
      }
      if (localStorage.getItem('userToken')) {
        localStorage.removeItem('userToken')
      }
      if (localStorage.getItem('loginUserName')) {
        localStorage.removeItem('loginUserName')
      }
      if (localStorage.getItem('loginUserId')) {
        localStorage.removeItem('loginUserId')
      }
      this.$message.warning("登出成功");
      router.push({path: "/"});
    },
    areaChange(value) {
      if (value && value.length) {
        finalAreaValue.value = value[value.length - 1];
      }
    },
  }
}

</script>

<style scoped>
.mode-col {
  height: 320px;
  width: 220px; /* 设置一个高度让背景显示出来 */
  background-size: contain;
  background-repeat: no-repeat; /* 背景图片覆盖整个元素 */
  transition: background-image 0.5s; /* 可选的，背景图变化过渡效果 */
  align-content: center;
  /*background-color: lightgray;*/
}

.welcome {
  /*background-image: url("../../assets/picture/FireEngine/fireHeader.png");*/
  background-color: blue;
}

.subjectBackground{
  background-image: url("@/assets/picture/FireEngine/subjectBackground.jpg");
  /*background-size: 120%;*/
  background-repeat: no-repeat;
  background-position: center;
  height: 600px;

}

/* 修改单选按钮内文字的颜色 */
.custom-radio-group :deep(.el-radio__input) {
  /* ... */
  width: 20px; /* 修改单选按钮的宽度 */
  height: 20px; /* 修改单选按钮的高度 */
}

.custom-radio-group :deep(.el-radio__label) {
  font-size: 20px; /* 修改字体大小 */
  color: white; /* 修改字体颜色 */
}

/*!* 如果需要深度选择 *!*/
/*::v-deep .el-sub-menu__title {*/
/*  color: black;*/
/*  font-size:18px ;*/
/*}*/

.el-menu {
  background-color: transparent;
  border-bottom-color: transparent;
}

/*.el-sub-menu{*/
/*  !*background-color: blue !important;*!*/
/*  !*color: blue !important;*!*/
/*  !*width: 200px;*!*/
/*  !*font-size: 18px;*!*/
/*  !*text-align: center !important;*!*/
/*}*/
/*.el-sub-menu .el-sub-menu__title {*/
/*  display: flex;*/
/*  align-items: center !important;*/
/*  justify-content: center !important;*/
/*}*/

.el-menu-item {
  background-color: transparent !important;
  color: black !important;
  font-weight: 50;
  width: 200px;
  font-size: 18px;
  text-align: center;
  &:not(.is-disabled):hover {
     color: gray !important;
     background-color: lightgray !important;
     width: 200px;
     text-align: center;
   }
}

</style>
